var $ = require('jquery');

$(function () {
    var slider = $('.featured-hero-slider__slide-container__carousel');
    var isPageEditor = window.SitecoreUtilities.isPageEditor;

    var currentProgressBar;
    var progressBarActive = true;
    var sliderAutoplayTimer;
    if (!isPageEditor()) {

        if ($('.featured-hero-slider__slide-container__status-bar__status-tile').length > 1) {
        var showArrows = false;
        var numCards = slider.length;
        var speed = 6000;
        if (numCards > 2) {
            showArrows = false;
        }

        slider.slick({
            arrows: false,
            infinite: true,
            speed: 700,
            slidesToShow: 1,
            centerMode: false,
            variableWidth: true,
            mobileFirst: true,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: speed,
            responsive: [{
                breakpoint: 991,
                arrows: false,
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
                variableHeight: true
            }],
            rtl: window.GenericUtilities.isRTL()
        });
        // to get slick slider to initialize on screen resize
        // https://github.com/kenwheeler/slick/issues/1730
        $(window).on('resize orientationchange', function () {
            slider.slick('resize');
            if (!progressBarActive) {
                slider.slick('pause');
                animateProgressBar(slider.slick('slickCurrentSlide'), "stop");
            }
        });
        //initialize the slider bar
        $('.featured-hero-slider__slide-container__status-bar__status-tile').each(function () {
            var t = $(this);
            var targetedIndex = t.attr('tileforslide');
            t.on('click',
                function () {
                    slider.slick('slickGoTo', targetedIndex);
                    slider.slick('slickPause');
                    animateProgressBar(targetedIndex, "stop");
                    //autoplayTimer(); //optional
                });
            if (targetedIndex == 0) { //start the animation for the first bar
                var progressBar = t.children('.featured-hero-slider__slide-container__status-bar__status-tile__progress-bar');
                currentProgressBar = progressBar;
                progressBar.animate({
                    right: 0
                        },
                        speed,
                        "linear",
                        function() {
                    //animation complete

                });
            }
        });

        function animateProgressBar(tileNum, command) {
            $('.featured-hero-slider__slide-container__status-bar__status-tile').each(function () {
                var t = $(this);
                var targetedIndex = t.attr('tileforslide');
                if (targetedIndex == tileNum) {
                    var progressBar = t.children('.featured-hero-slider__slide-container__status-bar__status-tile__progress-bar');
                    if (command == "stop") {
                        currentProgressBar.stop();
                        progressBarActive = false;
                    }
                    if (progressBarActive) {
                        currentProgressBar = progressBar;
                        progressBar.animate({
                            right: 0
                        }, speed, "linear", function () {
                            //animation complete
                        });
                    } else { //inactive progress bar. Progress bars now change instantly
                        //progressBar.addClass('filled');
                        var allBars = $('.featured-hero-slider__slide-container__status-bar__status-tile .featured-hero-slider__slide-container__status-bar__status-tile__progress-bar');
                        allBars.removeClass('filled').removeAttr('style');
                        for (var i = tileNum; i >= 0; i--) {
                            allBars[i].classList.add('filled');
                        }
                    }
                }
            });
        }

        function autoplayTimer() { //restarts the slider from a paused state
            clearTimeout(sliderAutoplayTimer);
            sliderAutoplayTimer = window.setTimeout(function () {
                var allBars = $('.featured-hero-slider__slide-container__status-bar__status-tile .featured-hero-slider__slide-container__status-bar__status-tile__progress-bar');
                allBars.each(function () {
                    var t = $(this);
                    if (t.hasClass('filled')) {
                        t.attr('style', 'right:0px;').removeClass('filled');
                    }
                });
                progressBarActive = true;
                slider.slick('play');
            }, 8000);
        }
        slider.on('swipe', function (event, slick, direction) {
            if (progressBarActive) {
                slider.slick('pause');
                animateProgressBar(slider.slick('slickCurrentSlide'), "stop");
                autoplayTimer();
            }
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            if (currentSlide == 0) {
                $('.featured-hero-slider__slide-container__status-bar__status-tile__progress-bar').each(function () {
                    $(this).removeAttr('style');
                });
            }
            animateProgressBar(currentSlide, "go");
        });

        } else if ($('.featured-hero-slider__slide-container__status-bar__status-tile').length === 1) {
            $('.featured-hero-slider__slide-container__status-bar__status-tile').css("display", "none");
        }
    } 
});